import { render, staticRenderFns } from "./card-escalate.vue?vue&type=template&id=563b2baa&scoped=true&"
import script from "./card-escalate.vue?vue&type=script&lang=js&"
export * from "./card-escalate.vue?vue&type=script&lang=js&"
import style0 from "./card-escalate.vue?vue&type=style&index=0&id=563b2baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b2baa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VChip,VExpansionPanel,VExpansionPanelContent,VIcon})
